export default "__VITE_ASSET__Iw_GlcEI__"